import { render, staticRenderFns } from "./permission_denied.vue?vue&type=template&id=dd23fcf0&scoped=true&"
import script from "./permission_denied.vue?vue&type=script&lang=js&"
export * from "./permission_denied.vue?vue&type=script&lang=js&"
import style0 from "./permission_denied.vue?vue&type=style&index=0&id=dd23fcf0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd23fcf0",
  null
  
)

export default component.exports